export const DEFAULT_RATED_POWER_BASED_ON_FOR_50 = 50;
export const DEFAULT_RATED_POWER_BASED_ON_FOR_60 = 60;
